import React, { useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import DeleteModal from "../components/DeleteModal";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import CustomContainer from "../components/Customsettingscontain";
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";

import { ApiUrl } from "../Constants/Weburl";
import Layout from "../components/Layout";
import SettingsPageShell from "../components/SettingsMenu";

export default function ReportReasons() {
  const [reportreasons, setReportreasons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editReasonId, setEditReasonId] = useState(null);
  const [title, setTitle] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(true);




  // Fetch reasons
  const fetchReasons = async () => {
    try {
      const res = await axios.get(`${ApiUrl}api/reportreasons`);

      console.log("res fetchreasons", res.data.data);

      setReportreasons(res.data.data);
    } catch (error) {
      console.log("Fetch reasons error:", error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReasons();
  }, []);

  // =========================
  // OPEN ADD MODAL
  // =========================
  const handleAdd = () => {
    setEditReasonId(null);
    setTitle("");
    setShowModal(true);
  };

  // =========================
  // OPEN EDIT MODAL
  // =========================
  const handleEdit = (reason) => {
    setEditReasonId(reason.id);
    setTitle(reason.title);
    setShowModal(true);
  };

  // =========================
  // CLOSE ADD / EDIT MODAL
  // =========================
  const closeReasonModal = () => {
    setShowModal(false);
    setEditReasonId(null);
    setTitle("");
  };

  // =========================
  // ADD / UPDATE
  // =========================
  const handleSubmit = async () => {
    // if (!title.trim()) {
    //   alert("Please enter report reason");
    //   return;
    // }

    try {
      let res;

      if (editReasonId) {
        // UPDATE
        res = await axios.put(
          `${ApiUrl}api/reportreasons/${editReasonId}`,
          {
            title: title.trim(),
          }
        );
      } else {
        // ADD
        res = await axios.post(`${ApiUrl}api/reportreasons`, {
          title: title.trim(),
        });
      }

      if (res.data.success !== false) {
        alert(
          editReasonId
            ? "Report reason updated successfully"
            : "Report reason added successfully"
        );

        fetchReasons();
        closeReasonModal();
      }
    } catch (error) {
      console.log("Save reason error:", error);

      alert(
        error.response?.data?.message ||
        "Something went wrong"
      );
    }
  };

  // =========================
  // OPEN DELETE MODAL
  // =========================
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // =========================
  // DELETE
  // =========================
  const deleteReason = async () => {
    if (!deleteId) return;

    try {
      const res = await axios.delete(
        `${ApiUrl}api/reportreasons/${deleteId}`
      );

      if (res.data.success !== false) {
        fetchReasons();

        setShowDeleteModal(false);
        setDeleteId(null);
      }
    } catch (error) {
      console.log("Delete reason error:", error);

      alert(
        error.response?.data?.message ||
        "Something went wrong"
      );
    }
  };



  return (
    <>
      <Layout>
        <SettingsPageShell
          title="REPORT REASONS"
          headerRight={
            <button className="rr-add-btn" onClick={handleAdd}>
              Add Report Reason
            </button>
          }
        >

          {loading ? (
            <div className="rr-card">
              <p>Loading...</p>
            </div>
          ) : (
            <div className="rr-card">
              <div className="rr-controls rr-controls-spaced">
                <div className="rr-left">
                  Show
                  <select className="rr-select">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                  </select>
                  entries
                </div>

                <div className="rr-right">
                  <span>Search:</span>
                  <input className="rr-search" type="text" />
                </div>
              </div>

              <CustomTable className="rr-table" striped={"false"}>
                <tr>
                  <th>Title</th>
                  <th className="rr-action-col">Action</th>
                </tr>

                {reportreasons.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td className="rr-actions">
                      <CustomButton
                        className="rr-icon-btn green"
                        onClick={() => handleEdit(item)}
                      >
                        <i className="bi bi-pencil"></i>
                      </CustomButton>
                      <CustomButton
                        className="rr-icon-btn red"
                        onClick={() => handleDeleteClick(item.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </CustomButton>
                    </td>
                  </tr>
                ))}
              </CustomTable>

              <div className="rr-footer">
                <span>
                  Showing 1 to {reportreasons.length} of {reportreasons.length} entries
                </span>
                <div className="rr-pagination">
                  <span className="rr-page-arrow">&lt;</span>
                  <span className="rr-page active">1</span>
                  <span className="rr-page-arrow">&gt;</span>
                </div>
              </div>
            </div>
          )}
        </SettingsPageShell>

        <Modal show={showModal} onHide={closeReasonModal} centered className="hashtag-add-modal">
          <Modal.Header className="hashtag-modal-header">
            <Modal.Title>{editReasonId ? "Edit Report Reason" : "Add Report Reason"}</Modal.Title>
            <CustomButton type="button" className="hashtag-close-btn" onClick={closeReasonModal}>
              ×
            </CustomButton>
          </Modal.Header>

          <Modal.Body className="hashtag-modal-body">
            <Form.Group>
              <Form.Label className="profile-pill">Report Reason</Form.Label>
              <Form.Control
                type="text"
                value={title}
                placeholder="Enter report reason"
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="hashtag-modal-footer">
            <CustomButton className="hashtag-close-footer-btn" variant="secondary" onClick={closeReasonModal}>
              Cancel
            </CustomButton>
            <CustomButton variant="primary" className="hashtag-save-btn" onClick={handleSubmit}>
              {editReasonId ? "Update" : "Submit"}
            </CustomButton>
          </Modal.Footer>
        </Modal>

        <DeleteModal
          show={showDeleteModal}
          close={() => {
            setShowDeleteModal(false);
            setDeleteId(null);
          }}
          onDelete={deleteReason}
          title="Delete Report Reason"
          message="Are you sure you want to delete this report reason?"
        />
      </Layout>
    </>
  );

}


